module.exports = __webpack_public_path__ + "img/document.7e7d40c1.png";